<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="标签名称" prop="tagName">
            <el-input style="width: 232px" v-model="searchForm.tagName" placeholder="请输入标签名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option label="启用" value="true"></el-option>
              <el-option label="禁用" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" prop="createdTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" :loading="exporting" @click="add()" icon="el-icon-plus">新增标签</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isS" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
          是否确认 {{ sName }} 该标签？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isS = false">取消</div>
          <div class="info-s" @click="upStatus">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="商品数据" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods" width="50%">
      <div style="height: 500px; overflow-y: auto">
        <el-table :data="goodsList" ref="multipleTable" border :header-cell-style="{
          'text-align': 'left',
          background: '#F8F8F8',
          color: '#333333',
        }">
          <el-table-column prop="goodsName" label="商品信息" width="220px">
            <template slot-scope="scope">
              <div style="display: flex">
                <img :src="scope.row.imgUrl" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                <div style="
                    font-size: 14px;
                    min-height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                  <p style="color: #333333">{{ scope.row.goodsName }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品类型">
            <template slot-scope="scope">
              {{ scope.row.goodsTypeLabel }}
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              {{ Number(scope.row.retailPrice).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div style="display: flex">
                <div :class="scope.row.status == 1 ? 'start' : 'end'"></div>
                <div>{{ scope.row.statusLabel }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="160px">
            <template slot-scope="scope">
              {{ scope.row.createdTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <div style="color: red" @click="deleteG(scope.row.id)">删除</div>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
          <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
            :current-page="page1.pageNo" :page-sizes="[5, 10, 20, 30]" :page-size="page1.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="page1.totalNum">
          </el-pagination>
        </div>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogGoods = false">取消</div>
        <div class="info-s" @click="dialogGoods = false">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      goodsList: [

      ],
      dialogGoods: false,
      isS: false,
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '标签管理', path: '/shopManagement/shopList', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '标签管理', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      list: [],
      searchForm: {
        tagName: '',
        status: '',
        createdTimeStart: "",
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 10
      },
      value1: [],
      value2: [],
      brandList: [],
      columns: [
        { label: '标签名称', prop: 'tagName', minWidth: '120' },
        {
          label: '标签图片',
          minWidth: '80',
          render: (h, scope) => {
            let img = scope.row.tagImg ? scope.row.tagImg : scope.row.tagImg
            return (
              <div>
                <el-image style="width:64px;height:64px;" src={img} preview-src-list={[img]} lazy></el-image>
              </div>
            )
          }
        },

        { label: '商品数', prop: 'goodsCount', minWidth: '100' },
        // { label: '平台', prop: 'platformName', minWidth: '120' },
        { label: '排序', prop: 'sort', minWidth: '130' },
        {
          label: '状态', prop: 'statusLabel', minWidth: '130',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '启用') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        { label: '创建时间', prop: 'createdTime', minWidth: '100' },
        {
          label: '操作',
          minWidth: '100',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add(scope.row.id) }}>编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:10px;margin-right:10px' onClick={() => { this.isStart(scope.row) }}>{scope.row.statusL}</span>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.look(scope.row.id) }}>查看商品</span>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      goodsSearch: {
        tagId: '',
        pageNo: 1,
        pageSize: 10,
      },
      exporting: false,
      sName: '启用',
      isStatus: '',
      tagId: null
    }
  },
  created() {
    this.getPageList()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'addTag') {
      next(vm => {
        vm.getPageList();
      });
    } else {
      next(vm => {
        vm.getPageList();
      });
    }
  },
  methods: {
    deleteG(id) {
      let msg = '是否确认删除该商品？'
      this.$confirm(msg, '温馨信息', {
        title: '温馨信息',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post('/tags/deleteTagGood', { id: id })
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success('删除成功')
              this.getShopList()
              this.getPageList()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    add(val) {
      this.$router.push({
        name: 'addTag',
        query: {
          id: val
        }
      })
    },
    getShopList() {
      this.goodsSearch.pageNo = this.page1.pageNo
      this.goodsSearch.pageSize = this.page1.pageSize
      this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
        .then(res => {
          console.log(res)
          this.goodsList = res.data.list;
          this.page1.totalNum = res.data.totalNum;

        })
    },
    look(id) {
      this.dialogGoods = true
      this.goodsSearch.tagId = id
      this.getShopList()
    },
    isStart(val) {
      this.isS = true
      this.sName = val.statusL
      this.tagId = val.id
      if (val.statusL == '启用') {
        this.isStatus = true
      } else {
        this.isStatus = false
      }

    },
    upStatus() {
      let data = {
        id: this.tagId,
        status: this.isStatus,
      }
      this.axios.post('/tags/updateStatus', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.isS = false
            this.getPageList()
          }

        })
    },
    exportFn() {
      this.exporting = true
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.joinTimeStart = this.value1[0];
        this.searchForm.joinTimeEnd = this.value1[1];
      } else {
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
      }
      if (this.value2) {
        this.searchForm.lastActiveTimeStart = this.value2[0];
        this.searchForm.lastActiveTimeEnd = this.value2[1];
      } else {
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }
      this.axios.post('/users/exportList', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code === 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.getPageList()
    },
    getPageList() {
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/tags/pageList', this.searchForm)
        .then(res => {
          console.log(res)
          res.data.list.forEach(item => {
            if (item.status == true) {
              item.statusLabel = '启用'
              item.statusL = '禁用'
            } else {
              item.statusLabel = '禁用'
              item.statusL = '启用'
            }
          })
          this.list = res.data.list;
          this.page.totalNum = res.data.totalNum;
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getPageList()
    },
    handleSizeChange1(e) {
      this.page1.pageSize = e;
      this.page1.pageNo = 1;
      this.getShopList()
    },
    handleCurrentChange1(e) {
      this.page1.pageNo = e;
      this.getShopList()
    },
    todetail(row) {
      this.$router.push({
        name: 'userDetail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 8px;
  margin-right: 5px;
}

.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 8px;
  margin-right: 5px;
}

/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__body {
    padding: 30px 25px;
    height: 800px;
    flex: 1;
    overflow: auto;
  }
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 37px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }

  .form-btn {
    /deep/ .el-form-item__content {
      line-height: 36px;
      margin-left: 50px;
    }
  }
}

/deep/ .el-table__row {
  .el-table__cell {
    padding: 12px 0;
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>

